import { IState } from '../../store';
import { EBookingStatus } from '../../types/newbuildingBooking';

export const selectIsBookingSuccess = (state: IState): boolean => {
  return state.newbuildingBooking.status === EBookingStatus.Success;
};
